// =============================================================================
// Workspace Page (Placeholder)
// =============================================================================

import React from 'react';

const WorkspacePage = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Workspace Page</h1>
      <p className="text-muted-foreground mt-2">
        This page will contain the main workspace interface with terminal, editor, and chat.
      </p>
    </div>
  );
};

export default WorkspacePage;
